@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText"></ms-market-help>
}
<div class="option-group-container total-score-container double">
    <ng-container *ngFor="let group of optionGroup?.options | slice: 0 : visibleOptionsLimit; trackBy: trackOption">
        <div class="attribute-key">{{ group.name }}</div>
        <ms-option
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [option]="group"
            [optionGroup]="optionGroup"
            [event]="event"
            [showOptionName]="false"
            [showPromoBadge]="!!crmPromoIdsMap.options[group.id]"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails">
        </ms-option>
    </ng-container>
</div>

@if (showMoreLessButtonVisible) {
    <div class="show-more-less-button" [ngClass]="{ expanded: expanded }" (click)="onShowMoreLessButtonToggle()">
        {{ expanded ? sitecore.event.ShowLess : sitecore.event.ShowMore }} <vn-icon name="theme-right" size="12" class="right-icon" />
    </div>
}
